import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import './styles/styles.css'
import Selection from "./Selection/";
import PhotoCamera from '@material-ui/icons/PhotoCamera';

interface Props {
    aspectRatio: number;
    launchBrowserButtonText?: string;
    postSelectionButtonText?: string;
    handleFileSelection:any;
    requiredType?:string;
    recommended: {
        width: number,
        height:number
    }
}

export default function ImageSelectionAndCropper({requiredType, handleFileSelection, aspectRatio, launchBrowserButtonText = 'Choose File', recommended, postSelectionButtonText}:Props) {
    // const { activeEvent, alertUser, handleClose } = props;
    const [open, setOpen] = useState(false);

    const useStyles = makeStyles(theme => ({
        root:{
            margin: '0 auto',
            maxWidth: '1200px'
        },
        dialogContent:{
            maxWidth: '1200px',
            width: '800px',

        },
        formControl: {
            margin: theme.spacing(1),
        },
        input: {
            display: 'none',
        },
        progress: {
            margin: '5px 0',
            padding: '5px 0',
        },
    }));
    const handleClose = () =>{
        setOpen(false)
    }

    const classes = useStyles();

    return (
        <>
            <Button startIcon={<PhotoCamera/>} onClick={()=>setOpen(true)} color="secondary" variant="contained" component="span">
                {launchBrowserButtonText}
            </Button>
            <div>
                <Dialog PaperProps={{style:{display:'flex', justifyContent:'center', minWidth: '400px', width: 'fit-content', maxWidth:'1200px'}}} className={classes.root}  aria-labelledby="form-dialog-title" onClose={handleClose} open={open}>
                    <DialogTitle id="form-dialog-title">Image selection</DialogTitle>
                    <DialogContent  style={{ paddingBottom: 10 }}>
                       <Selection
                           closeModal={()=>setOpen(false)}
                           postSelectionButtonText={postSelectionButtonText}
                           handleSuccess={handleFileSelection}
                           aspectRatio={aspectRatio}
                           requiredType={requiredType}
                           recommended={recommended} />
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}
